import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AppConsts } from '@shared/AppConsts';
import { CompanyProfileCountryLookupTableDto, CompanyProfileServiceProxy, CountryMasterDto, CountryStateCityAppserviceServiceProxy } from '@shared/service-proxies/service-proxies';

@Component({
    selector: 'app-country-dropdown',
    templateUrl: './country-dropdown.component.html',
    styleUrls: ['./country-dropdown.component.css']
})
export class CountryDropdownComponent implements OnInit {

    @Output() EmitId = new EventEmitter<number>();
    // Input properties
    @Input() countryId: number;
    @Input() formsubmitted: boolean;
    @Input() isdisabled: boolean;
    @Input() dropDownPosition: string;
    allCountry: CountryMasterDto[] = [];
    flagselected: string = '';
    countryIdrecieved: number;
    constructor(private _companyProfilesServiceProxy: CompanyProfileServiceProxy, private _countryStateCityAppserviceServiceProxy: CountryStateCityAppserviceServiceProxy) { }

    ngOnInit(): void {
        if (this.dropDownPosition == '') {
            this.dropDownPosition = 'bottom';
        }

        this.getCompanyProfile();
        if (this.countryId)
            this.allCountry.forEach(x => { if (x.id === this.countryId) this.flagselected = x.tld });
        // if(this.countryId){
        //   this.flagselected= this.allCountry.map(x =>{ if(x.id==this.countryId)return x.flag;})
        // }
        // console.log("is form submitted", this.formsubmitted);
    }
    ngOnChanges() {
        if (this.countryId)
            this.allCountry.forEach(x => { if (x.id === this.countryId) this.flagselected = x.tld });
        else
            this.flagselected = '';

        //console.log("is form submitted ngonchange", this.formsubmitted);
        //this.flagselected == '';
    }

    getCompanyProfile() {
        if (!AppConsts.allCountry) {
            this._countryStateCityAppserviceServiceProxy.getAllCountry().subscribe(result => {
                AppConsts.allCountry = result; this.getCompanyProfileAfterApi(result);
            });
        } else { this.getCompanyProfileAfterApi(AppConsts.allCountry); }
        // this._companyProfilesServiceProxy.getAllCountryForTableDropdown().subscribe(result => {
        //     this.allCountry = result.filter((country) => {
        //         return country.displayName !== '';
        //     }).sort((a, b) => a.displayName.localeCompare(b.displayName));
        //     this.allCountry.forEach(x => { if (x.id === this.countryId) this.flagselected = x.flag });
        // });
    }
    getCompanyProfileAfterApi(result) {
        this.allCountry = result.filter((country) => {
            return country.name !== '';
        }).sort((a, b) => a.name.localeCompare(b.name));
        this.allCountry.forEach(x => { if (x.id === this.countryId) this.flagselected = x.tld });
    }

    SelectedCountry(event: CompanyProfileCountryLookupTableDto) {
        if (!event) {
            this.flagselected = '';
            this.EmitId.emit(undefined);
        } else {
            this.allCountry.forEach(x => { if (x.id === event.id) this.flagselected = x.tld });
            this.EmitId.emit(event.id);
        }

    }
}
